import { Routes } from '@angular/router';
import { LoginComponent } from './modules/auth/components/pages/login/login.component';
import { ResetPasswordComponent } from './modules/auth/components/pages/reset-password/reset-password.component';
import { AboutUsComponent } from './modules/contact-us/components/pages/about-us/about-us.component';
import { AuthGuardService } from './modules/auth/services/auth-guard.service';
import { TermsAndConditionsComponent } from './modules/contact-us/components/pages/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './modules/contact-us/components/pages/privacy-policy/privacy-policy.component';
import { Permissions } from './modules/auth/permissions/permissions';
import { ResetPasswordOtpComponent } from './modules/auth/components/pages/reset-password-otp/reset-password-otp.component';
import { NewPasswordComponent } from './modules/auth/components/pages/new-password/new-password.component';


export const baseRoutes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent,
    },
    {
        path: 'reset-password-otp',
        component: ResetPasswordOtpComponent,
    },
    {
        path: 'new-password',
        component: NewPasswordComponent,
    },
    {
        path: 'about-us',
        component: AboutUsComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR, Permissions.IS_SUPER_ADMIN, Permissions.IS_DELIVERY_MANAGER] }
    },
    {
        path: 'terms-and-conditions',
        component: TermsAndConditionsComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR, Permissions.IS_SUPER_ADMIN, Permissions.IS_DELIVERY_MANAGER] }
    },
    {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
        canActivate: [AuthGuardService],
        data: { permission: [Permissions.IS_VENDOR, Permissions.IS_SUPER_ADMIN, Permissions.IS_DELIVERY_MANAGER] }
    },
]

export const routes: Routes = [

]
